import React from 'react'
import styled from 'styled-components/macro'

import margin from '../../styles/margin'

const Component = styled.button`
  ${margin};

  border: 1px solid
    ${(props) =>
      props.checked
        ? props.theme.colors.brand.secondary
        : props.theme.colors.brand.primary};
  background: ${(props) =>
    props.checked ? props.theme.colors.brand.secondary : 'none'};
  border-radius: 4px;
  padding: 16px;
  width: 100%;
  min-width: 320px;
  max-width: 328px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    filter: brightness(110%);
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }

  @media only screen and (min-width: 768px) {
    max-width: none;
  }
`

const Text = styled.span`
  font-family: 'Pluto Sans', sans-serif;
  color: ${(props) =>
    props.checked
      ? props.theme.colors.grey.white
      : props.theme.colors.brand.primary};
  font-size: 16px;
  line-height: 24px;
  text-align: left;
`

const Box = styled.div`
  flex-shrink: 0;
  border: 2px solid
    ${(props) =>
      props.checked
        ? props.theme.colors.grey.white
        : props.theme.colors.grey.grey5};
  position: relative;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  background: ${(props) => props.theme.colors.grey.white};
`

const Check = styled.div`
  &:after {
    animation-duration: 400ms;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }

  &:after {
    opacity: 1;
    height: 9px;
    width: 5px;
    transform-origin: left top;
    border-right: 2px solid ${(props) => props.theme.colors.brand.secondary};
    border-top: 2px solid ${(props) => props.theme.colors.brand.secondary};
    content: '';
    left: 3px;
    top: 9px;
    position: absolute;
  }

  @keyframes checkmark {
    0% {
      height: 0;
      width: 0;
      opacity: 1;
    }
    20% {
      height: 0;
      width: 5px;
      opacity: 1;
    }
    40% {
      height: 9px;
      width: 5px;
      opacity: 1;
    }
    100% {
      height: 9px;
      width: 5px;
      opacity: 1;
    }
  }
`

const CheckBox = ({
  title,
  value,
  apiName,
  checked,
  onClick,
  enabled,
  ...styles
}) => (
  <Component
    checked={checked}
    onClick={enabled ? onClick(value, apiName) : undefined}
    {...styles}
  >
    <Text checked={checked}>{title}</Text>
  <Box checked={checked}>{checked && <Check />}</Box>
  </Component>
)

export default CheckBox
